import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppSettings } from '../shared/AppSettings';
import { shareReplay } from 'rxjs/internal/operators/shareReplay';
import { RecurrJnlEditPageSearchResultModel, RecurrJnlPageSelectModel, tRecurrJnlModel } from '../models/tRecurrJnlModel';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

@NgModule({
    imports: [CommonModule, FormsModule]
})

@Injectable({
    providedIn: 'root'
})
export class tRecurrJnlService {

    constructor(private http: HttpClient) { }

    baseurl: string = AppSettings.BaseURI;

    readonly pathName = '/tRecurrJnl';

    getAllData() {
        return this.http.get<tRecurrJnlModel[]>(this.baseurl + this.pathName);
    }

    newJournal(data: tRecurrJnlModel[]) {
        return this.http.post(this.baseurl + this.pathName+ '/newRecurrJnl', data);
    }

    getAllRecurrData(shopID:string){
        return this.http.get<RecurrJnlPageSelectModel[]>(this.baseurl + this.pathName+'/getRecurrJnl/'+shopID);
    }

    getRecurrData(recurrID:string){
        return this.http.get<RecurrJnlEditPageSearchResultModel>(this.baseurl + this.pathName+'/'+recurrID);
    }

    deleteRecurrJnl(recurrID:string){
        return this.http.delete(this.baseurl + this.pathName+'/'+recurrID);
    }

}